/**
 * Helper compartido — vam_test_kind → sufijo visible para el atleta.
 *
 * v16.1 §8 sub-bloque 3: muestra distinción entre los kinds de TEST-VAM
 * al renderizar el nombre de la sesión. Reutilizado por SessionCard
 * (vista semanal) y SessionDetailPage (vista detalle) para mantener
 * consistencia entre ambas vistas.
 *
 * Convención de la cadena devuelta:
 * - Incluye un espacio inicial EXPLÍCITO en código (no escondido en
 *   las claves i18n): el resultado es `" (inicial)"` no `"(inicial)"`.
 *   Razón: espacios al inicio de cadenas i18n son traps silenciosos
 *   (un refactor futuro los puede borrar sin notar). Centralizamos la
 *   convención visual aquí.
 * - Para `null` o `undefined` devuelve `""` — defensa silenciosa para
 *   sesiones test_vam legacy sin backfill (no debería ocurrir tras la
 *   migración a1b2c3d4e5f6 del sub-bloque 1, pero el frontend no
 *   reventa si llega).
 *
 * Uso típico:
 *   `${typeLabel}${labelForVamTestKind(session.vam_test_kind)}`
 *   → "TEST-VAM (inicial)" cuando kind='initial'
 *   → "TEST-VAM"            cuando kind=null
 *
 * Valores admitidos:
 * - 'initial'  — único kind emitido por el motor desde v16.1 §8 sub-bloque 2.
 * - 'periodic' — LEGACY (planes pre-v16.1 backfilleados).
 * - 'final'    — FUTURO (recovery week post-carrera, no implementado).
 */
import { t } from "@/i18n/es";
import type { VamTestKind } from "@/types/api";

export function labelForVamTestKind(
  kind: VamTestKind | null | undefined,
): string {
  switch (kind) {
    case "initial":
      return ` ${t.plan.vamTestKindInitialLabel}`;
    case "periodic":
      return ` ${t.plan.vamTestKindPeriodicLabel}`;
    case "final":
      return ` ${t.plan.vamTestKindFinalLabel}`;
    default:
      // null o undefined → sin sufijo (defensa para legacy sin backfill).
      return "";
  }
}
